module.exports = __webpack_public_path__ + "static/media/debugIco.f389ca79.svg";